import { z } from 'zod/v3';

// ============================================================================
// Cart Model 스키마
// ============================================================================

/**
 * 장바구니 상품 개수 스키마
 * @description 응답이 원시 타입 number
 * @see GET /api/market-place/v1/shopping-cart-items/count
 */
export const cartCountSchema = z.number();
export type CartCount = z.infer<typeof cartCountSchema>;
